"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiError = void 0;
class ApiError extends Error {
  constructor({
    payload,
    status = 0,
    statusText = 'Unspecified error',
    headers = {}
  }) {
    super(`API Error (${status}): ${statusText}`);
    this.payload = payload;
    this.status = status;
    this.statusText = statusText;
    this.headers = headers;
  }
}
exports.ApiError = ApiError;